import { useState, useEffect } from 'react';

const getWindowWidth = (): number =>
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth;

const getWindowHeight = (): number =>
  window.innerHeight ||
  document.documentElement.clientHeight ||
  document.body.clientHeight;

interface UseWindowSizeReturns {
  width: number;
  height: number;
}

export default function useWindowSize(throttle = 150): UseWindowSizeReturns {
  // save current window width in the state object
  const [width, setWidth] = useState(getWindowWidth());
  const [height, setHeight] = useState(getWindowHeight());

  // in this case useEffect will execute only once because
  // it does not have any dependencies.
  useEffect(() => {
    let isMounted = true;

    let timeoutId: NodeJS.Timeout | undefined = undefined;
    const resizeListener = (): void => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        if (isMounted) {
          setWidth(getWindowWidth());
          setHeight(getWindowHeight());
        }
      }, throttle);
    };
    // set resize listener
    window.addEventListener('resize', resizeListener);

    return () => {
      isMounted = false;
      window.removeEventListener('resize', resizeListener);
    };
  }, [throttle]);

  return { width, height };
}
